import apiManager from '@/api';

const module = {
  namespaced: true,
  state: () => ({
    eventTypes: [],
  }),
  mutations: {
    setEventTypes(state, eventTypes) {
      state.eventTypes = eventTypes;
    },
  },
  getters: {
    eventType: (state) => (id) => state.eventTypes
      .find((type) => type.id === id),
    filterOptions: (state) => state.eventTypes.filter((x) => x.name !== 'IN-PERSON/VIRTUAL'),
  },
  actions: {
    async loadEventTypes({ commit }) {
      const types = await apiManager.eventTypes.getAll();
      commit('setEventTypes', types);
    },
  },
};

export default module;
